import { render, staticRenderFns } from "./DocTypeDetail.vue?vue&type=template&id=46fc42c4"
import script from "./DocTypeDetail.vue?vue&type=script&lang=js"
export * from "./DocTypeDetail.vue?vue&type=script&lang=js"
import style0 from "./DocTypeDetail.vue?vue&type=style&index=0&id=46fc42c4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports